<template>
  <div class="h-full">
    <div class="flex h-full justify-end items-center">
      <vs-dropdown
        style="margin-left: 5px; cursor: pointer"
        vs-custom-content
        vs-trigger-click
      >
        <vs-button
          color="primary"
          type="border"
          icon-pack="feather"
          icon="icon-more-vertical"
        ></vs-button>

        <vs-dropdown-menu style="min-width: 100px">
          <vs-dropdown-item @click="coursePreviewNewTab(params.data.slug)"
            >View</vs-dropdown-item
          >
          <vs-dropdown-item @click="cloneCourse(params.data.slug)"
            >Clone</vs-dropdown-item
          >
          <vs-dropdown-item
            v-if="checkingEditPermission()"
            @click="openEditView(params.data)"
            >Edit</vs-dropdown-item
          >
          <vs-dropdown-item
            v-if="
              checkingDeletePermission() && courseApplicationType !== 'Shared'
            "
            @click="
              openConfirm(params.data.id, params.data, 'single', 'Course')
            "
            >Delete</vs-dropdown-item
          >
          <vs-dropdown-item @click="awardCertificate">Award Certificate</vs-dropdown-item>
          <vs-dropdown-item
            v-if="checkEnrollPermission() && courseApplicationType == 'General'"
            @click="enrolledUser"
            >Teachers</vs-dropdown-item
          >
          <vs-dropdown-item
            v-if="params.data.status"
           @click="enrollmentPopUp">Enrol Student</vs-dropdown-item
          >
        </vs-dropdown-menu>
      </vs-dropdown>
    </div>
    <!-- <div v-if="enrollmentModal">
    <vs-popup
        fullscreen
        classContent="popup-example"
        title="Enrol Student"
        :active.sync="enrollmentModal">
      <Enrollment :course_id="course_id" :detailsCourse="params.data"  @enrollmentComplete="enrollmentComplete" />
    </vs-popup>
  </div> -->
  </div>
</template>

<script>
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { DeleteMixin } from '../../mixins/DeletingMixins'
import { cloneCourse } from '@/api/courseBuilder.js'
// import { shareCertificate} from '@/api/certificate'

// import Enrollment from '@/views/pages/v1/admission/newEnrollment.vue'

export default {
  // components:{
  //   Enrollment
  // },
  mixins: [PermissionMiddleware, DeleteMixin],
  name: 'CellRendererAction',
  created () {
    const role_permission = parseInt(localStorage.getItem('role_permission'))
    if (role_permission === 1) {
      this.schoolAdmin = true
    } else {
      this.schoolAdmin = false

      this.getModulePermission('Course')
    }
  },
  data () {
    return {
      course_id:null,
      enrollmentModal:false,
      courseApplicationType: '',
      listingtype: 'course'
    }
  },
  mounted () {
    this.courseApplicationType =
      this.params.colDef.filterParams.courseApplicationType
  },
  methods: {
    enrollmentPopUp () {
      // this.course_id = this.params.data.id
      // this.enrollmentModal = true
      this.params.colDef.filterParams.openEnrollmentPopup(
        this.params.data.id,
        this.params.data
      )
    },
    // async share_certificate () {
    //   const customer_id = this.$store.getters.customerId
    //   let payload = []

    //   try {
    //     payload = {
    //       certificate_ids:[this.params.data.certificate_template_id]
    //     }

    //     await shareCertificate(payload, customer_id)
    //     this.$vs.notify({
    //       title: 'Success',
    //       text: 'Shared Certificate Successfully',
    //       iconPack: 'feather',
    //       icon: 'icon-alert-circle',
    //       color: 'success',
    //       time: 3000
    //     })


    //   } catch (error) {
    //     //
    //   }
    // },
    async awardCertificate () {
      this.params.colDef.filterParams.awardCertificate(this.params.data)
      // if (!this.params.data.certificate_award_method_id) {
      //   return this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Choose a certificate method first',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning',
      //     time: 2000
      //   })
      // }
      // if (!this.params.data.certificate_template_id) {
      //   return this.$vs.notify({
      //     title: 'Warning',
      //     text: 'Choose a certificate template',
      //     iconPack: 'feather',
      //     icon: 'icon-alert-circle',
      //     color: 'warning',
      //     time: 2000
      //   })
      // }

      // this.share_certificate()
    },
    async enrollmentComplete () {
      this.enrollmentModal = false
    },
    cloneCourse () {
      cloneCourse(this.$store.getters.customerId, this.params.data.id)
        .then((data) => {
          this.$vs.notify({
            title: 'Success',
            text: 'Course cloned successfully',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success',
            time: 2000
          })
          this.params.colDef.filterParams.fetchCourseList()
        })
        .catch((e) => {
          console.log(e)
        })
    },
    enrolledStudent () {
      this.params.colDef.filterParams.enrolledStudent(
        this.params.data.id,
        this.params.data.students
      )
    },
    enrolledUser () {
      this.params.colDef.filterParams.enrolledUser(
        this.params.data.id,
        this.params.data.tutors
      )
    },
    sharingCourse () {
      this.params.colDef.filterParams.sharingCourse(
        this.params.data.id,
        this.params.data.sharedUserList,
        this.params.data.courseSetting.course_class_type
      )
    },
    sharingCertificate () {
      if (this.params.data.courseSetting.certificate_share_type === 1) {
        this.params.colDef.filterParams.sharingCertificate(this.params.data)
      } else {
        this.showSuccessMessage(
          'Error',
          'Please choose a certificate template',
          'danger'
        )
      }
    },
    checkingEditPermission () {
      if (
        (this.checkEditPermission() &&
          this.courseApplicationType === 'General') ||
        (this.customEditAction && this.courseApplicationType === 'Custom') ||
        this.courseApplicationType === 'Shared'
      ) {
        return true
      } else {
        return false
      }
    },
    checkingDeletePermission () {
      if (
        (this.checkDeletePermission() &&
          this.courseApplicationType === 'General') ||
        (this.customDeleteAction && this.courseApplicationType === 'Custom')
      ) {
        return true
      } else {
        return false
      }
    },
    coursePreviewNewTab () {
      this.$router.push({
        name: 'course preview',
        params: {
          course_open_type: 'preview',
          course_id: this.params.data.id
        }
      })
    },

    openEditView () {
      console.log(this.params.data)
      if (this.courseApplicationType === 'Custom') {
        localStorage.setItem('courseActionType', 'customEdit')
      } else if (this.courseApplicationType === 'Shared') {
        localStorage.setItem('courseActionType', 'Shared')
      } else {
        localStorage.setItem('courseActionType', 'Edit')
      }

      // this.$router.push({
      //   name: 'course-builder',
      //   params: {
      //     editing_object: editingObject,
      //     editing_type: 'Course',
      //     section: 'course',
      //     courseApplicationType: this.courseApplicationType
      //   }
      // })

      this.$router.push({
        name: 'course edit',
        params: {
          course_id: this.params.data.id,
          course_class_type: this.params.data.course_class_type
        }
      })
      setTimeout(() => {
        localStorage.removeItem('courseActionType')
      }, 5000)
    }
  }
}
</script>
